export default __webpack_public_path__ + "static/media/logo_sparkle.1640ff8d.gif";